import tw from 'tailwind-styled-components'
import {VirtualizeParams} from 'yougile-util'
import {DataObjectId, DealActivityDealItem, Hub} from 'yougile-model'
import {TableDataType, TableRow} from '../common/base/table/types'

export interface RowData extends TableDataType<string> {
  task: Hub | undefined
  organization: Hub | undefined
  contactPerson: Hub | undefined
  activity: DealActivityDealItem
}

export const rowHeight = 32
export const virtualize: VirtualizeParams = {
  perPage: 20,
  positionToRow: top => Math.floor(top / rowHeight),
  rowToPosition: ix => ix * rowHeight,
  containerHeight: rows => rows * rowHeight
}

export interface CrmActivitiesFilters {
  page: 'day' | 'failed' | 'completed'
  selectedDay: number
  assigned: DataObjectId[]
}

export const TwMain = tw.div`
  absolute
  left-16
  right-16
  bottom-0
  top-[132px]
  h-fit-content
  overflow-hidden
`

export const CardBox = tw.div<{isResult?: boolean}>`
  bg-primary
  rounded-tl-12
  rounded-tr-12
  flex
  flex-col
  items-start
  justify-start
  h-fit
  !p-16
`

export interface CrmActivitiesStats {
  dayCurrent: number
  dayPrev: number
  dayNext: number
  failed: number
  completed: number
}

export interface CrmActivitiesView {
  tableRows?: TableRow<RowData>[]
  depIds?: DataObjectId[]
  stats?: CrmActivitiesStats
  projectUsersIds?: DataObjectId[]
}
